<template>
  <v-layout column px-3>
    <v-flex xs2 align-self-end>
      <table-columns ></table-columns>
    </v-flex>
    <v-flex >
      <list :items="filteredItems" :rowsPerPage="rowsPerPage"></list>
    </v-flex>
  </v-layout>
</template>
<script>
import List from "./list";
import TableColumns from "./tableColumns.vue";

export default {
  components: { List, TableColumns },
  props: {
    checks: {
      type: Array,
    },
    summaryView: Boolean,
    selectedItem: Number,
    search: {
      type: Object,
    },
  },
  data() {
    return {
      pages: [5, 10, 15, 20, 50, 100],
      rowsPerPage: 20,
      showColumnsTable: false,
      menu: false,
    };
  },
  computed: {
    filteredItems() {
      const mergeDeep = (arr) => {
        return [...new Set([].concat(...arr))];
      };

      const checks = JSON.parse(JSON.stringify(this.checks));

      let itemArray = checks.map((c) => {
        return c.items.map((i) => {
          i.table_name = c.table_name;
          i.sale_open_date = c.sale_open_date;
          i.icon = c.icon;
          i.service_type = c.service_type;
          i.check_number = c.check_number;
          i.ticket_name = c.ticket_name;
          i.store_name = c.store_name;
          return i;
        });
      });

      const filtered = mergeDeep(itemArray);

      const sort = Number(this.search.sortOrder);
      let result = filtered.sort((a, b) => {
        // let d1 = Number(a.kot_sent_time.replace(/\D/g, ""));
        // let d2 = Number(b.kot_sent_time.replace(/\D/g, ""));
        let d1 = a.kot_number;
        let d2 = b.kot_number;
        if (d1 < d2) return sort * -1;
        if (d1 > d2) return sort;
        return 0;
      });

      return result;
    },
  },
};
</script>
